import { axiosInstance } from "./ServiceConstants";
import { ISearchResult } from "../models/ISearchResult";

class SearchService {
  async search(term: string): Promise<ISearchResult> {
    const response = await axiosInstance.get<ISearchResult>(
      `api/search?term=${encodeURIComponent(term)}`
    );
    return response.data;
  }
}

const SearchServiceInstance = new SearchService();
export default SearchServiceInstance;
